import { InvoiceTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1851. 請求タスクフェーズ更新（前へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/move_to_prev_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  current_invoice_task_phase_id: number;
};

const moveInvoiceTaskPhaseToPrev = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/move_to_prev_phase`,
    props
  );
};

export const useMoveInvoiceTaskPhaseToPrev = () => {
  return useMutation({
    mutationFn: moveInvoiceTaskPhaseToPrev
  });
};